(function() {

  const inViewCss = new InViewCssVariables({
    baseClass: 'u-inview-css',
    positionTrackClass: 'u-inview-css--track-scroll-position'
  })

  class ParallaxEffect {
    constructor(element) {
      this.element = element;
      this.parallaxContent = element.querySelector('.u-parallax__content');

      waitForImages(this.element, () => {
        // refresh height on resize
        window.addEventListener('resize', () => {
          this.calculateParallaxSize();
          this.checkPosition();
        })
        // check position on scroll
        document.addEventListener('scroll', (e) => {
          this.calculateParallaxSize();
          this.checkPosition();
        });
        // check position on parallax-height-adujust
        element.addEventListener('parallax-height-adujust', (e) => {
          this.calculateParallaxSize();
          this.checkPosition();
          e.detail.callback();
        });

        this.calculateParallaxSize();
        this.checkPosition();
      })
    }
    calculateParallaxSize() {
      this.element.classList.remove('u-parallax--fixed-top'); 
      // set height of wrapper and set content to fixed position
      this.element.style.height = `${this.parallaxContent.offsetHeight}px`;
      this.element.style.maxHeight = `${this.parallaxContent.offsetHeight}px`;
  
      // set fixed top if parallax content is bigger than screen
      if(this.parallaxContent.offsetHeight > window.innerHeight) {
        this.element.classList.add('u-parallax--fixed-top'); 
      }
    }
    checkPosition() {
      let windowTop = window.pageYOffset;
      let windowBottom = windowTop + window.innerHeight;
      let parallaxTop = this.element.getBoundingClientRect().top;
      let parallaxRelativeTop = windowTop + parallaxTop;
      let parallaxRelativeBottom = parallaxRelativeTop + this.element.offsetHeight;
      let parallaxContentTop = this.parallaxContent.getBoundingClientRect().top;
  
      if(Math.max(parallaxTop, 0) < windowBottom && windowBottom < parallaxRelativeBottom && parallaxTop >= 0) {
        this.element.classList.add('u-parallax--fixed');
      } else {
        this.element.classList.remove('u-parallax--fixed');
      }
    }
  }

  function contentOnScrollLoad() {

    // init inviewcssvariables

    inViewCss.checkAllElements()

    /** 
     * PARALLAX
     */
    
    const parallaxElements = document.querySelectorAll('.u-parallax');
    parallaxElements.forEach((element) => {
      if(!element.classList.contains('u-parallax--initialized')) {
        new ParallaxEffect(element);
        element.classList.add('u-parallax--initialized');
      }
    })
    
  }

  document.addEventListener("page-load-complete", function () {
    contentOnScrollLoad();
  });

  document.addEventListener('overlay-content-ready', function () {
    contentOnScrollLoad();
  });

})();